import GunbotStorage from 'assets/js/gunbot.storage';
import React, { useState, createContext, useCallback, useMemo } from 'react';

const isFamiliar = GunbotStorage.get('isKnowWellGunbot', false);
const isFamiliarUpTo = parseFloat(GunbotStorage.get('isKnownWellUpTo', '0'))

export const StepGuideContext = createContext({
  isKnowWell: false,
  setKnowWell: knowWell => {},
  isPending: false,
  currentStep: 1,
  setupStep: 10,
  tradingSettingStep: 2,
  manualStep: 10 + 2,
  pairConfigStep: 5,
  totalStep: 15,
  setCurrentStep: step => {},
  setTotalStep: step => {},
  setPending: isPending => {},
  setSetupStep: step => {},
  setTradingSettingStep: step => {},
  setPairConfigStep: step => {},
});

const StepGuideProvider = ({ children }) => {
  const [isKnowWell, setIsKnowWell] = useState(isFamiliar);
  const [isKnowWellUpTo, setIsKnowWellUpTo] = useState(isFamiliarUpTo);
  const [isPending, setPending] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [setupStep, setSetupStep] = useState(10);
  const [tradingSettingStep, setTradingSettingStep] = useState(2);
  const [pairConfigStep, setPairConfigStep] = useState(5);

  const handleIsKnowWell = useCallback(() => {
    const knownUpTo = parseFloat(GunbotStorage.get('isKnownWellUpTo', '0'))

    if (knownUpTo < 1) {
      GunbotStorage.set('isKnownWellUpTo', '1')
      setIsKnowWellUpTo(1)
    }
    else if (knownUpTo < 2) {
      GunbotStorage.set('isKnownWellUpTo', '2')
      setIsKnowWellUpTo(2)
    }
    else if (knownUpTo < 3) {
      GunbotStorage.set('isKnownWellUpTo', '3')
      setIsKnowWellUpTo(3)
    }

    GunbotStorage.set('isKnowWellGunbot', true);
    setIsKnowWell(true);
  }, []);

  const value = useMemo(() => {
    return {
      isKnowWell,
      isKnowWellUpTo,
      currentStep,
      setupStep,
      manualStep: setupStep + tradingSettingStep,
      isPending,
      totalStep: setupStep + tradingSettingStep + pairConfigStep,
      setKnowWell: handleIsKnowWell,
      setCurrentStep,
      setSetupStep,
      setTradingSettingStep,
      setPairConfigStep,
      setPending,
    };
  }, [isKnowWell, isKnowWellUpTo, currentStep, setupStep, isPending, tradingSettingStep]);

  return <StepGuideContext.Provider value={value}>{children}</StepGuideContext.Provider>;
};

export default StepGuideProvider;
